import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

export default function BasicInfoSection({ form, setForm }) {
  return (
    <Box className="candidate-section">
      <Box className="candidate-section-head">
        <Typography className="candidate-section-kicker">Section 1</Typography>
        <Typography className="candidate-section-title">Basic Information</Typography>
        <Typography className="candidate-section-subtitle">
          Capture the candidate identity, contact route, and hiring stage context.
        </Typography>
      </Box>

      <Box className="candidate-grid two-col">
        <TextField
          label="Full Name"
          fullWidth
          value={form.full_name}
          onChange={(e) => setForm({ ...form, full_name: e.target.value })}
        />
        <TextField
          label="Email"
          fullWidth
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <TextField
          label="Phone"
          fullWidth
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
        />
        <TextField
          label="Address"
          fullWidth
          value={form.address}
          onChange={(e) => setForm({ ...form, address: e.target.value })}
        />
      </Box>

      <Box className="candidate-grid two-col">
        <TextField
          label="Current Job Title"
          fullWidth
          value={form.current_job_title}
          onChange={(e) =>
            setForm({ ...form, current_job_title: e.target.value })
          }
        />
        <TextField
          select
          label="Recruitment Stage"
          fullWidth
          value={form.recruitment_stage}
          onChange={(e) =>
            setForm({ ...form, recruitment_stage: e.target.value })
          }
        >
          <MenuItem value="screening">Screening</MenuItem>
          <MenuItem value="interview">Interview</MenuItem>
          <MenuItem value="offer">Offer</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
        </TextField>
        <TextField
          label="Expected Salary"
          fullWidth
          value={form.expected_salary}
          onChange={(e) =>
            setForm({ ...form, expected_salary: e.target.value })
          }
        />
        <TextField
          label="Current Salary"
          fullWidth
          value={form.current_salary}
          onChange={(e) =>
            setForm({ ...form, current_salary: e.target.value })
          }
        />
      </Box>

      <Box className="candidate-note-card">
        <Box className="candidate-grid two-col">
          <TextField
            label="Joining Availability Date"
            fullWidth
            type="date"
            InputLabelProps={{ shrink: true }}
            value={form.joining_availability_date}
            onChange={(e) =>
              setForm({
                ...form,
                joining_availability_date: e.target.value,
              })
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={form.relocate}
                onChange={(e) =>
                  setForm({ ...form, relocate: e.target.checked })
                }
              />
            }
            label="Willing to Relocate"
          />
        </Box>

        <TextField
          label="Notes"
          fullWidth
          multiline
          rows={4}
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
        />
      </Box>
    </Box>
  );
}
